import React from 'react'
import CardStack from '../templates/CardStack'
import Branding from '../templates/Branding'

class CardStackHOC extends React.Component {


render () {
  return (
    <Branding>
      <CardStack onNextPage={this.props.onNextPage} visibleClass={this.props.visibleClass} arrowLink={this.props.arrowLink} buttonText={this.props.buttonText} buttonClickHandler={this.props.buttonClickHandler } >
        { this.props.children }
      </CardStack>
    </Branding>
  )
}

}


export default CardStackHOC



// WEBPACK FOOTER //
// ./src/components/CardStackHOC.js